module.exports = __webpack_public_path__ + "e3ac728c6286182ecee6047ba2d84627.svg";